import { render, staticRenderFns } from "./FaqSearchBox.vue?vue&type=template&id=15e6a22d&scoped=true&"
import script from "./FaqSearchBox.vue?vue&type=script&lang=js&"
export * from "./FaqSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e6a22d",
  null
  
)

export default component.exports